<main class="app">

  <img class="app--logo1" src="assets/logo-cliente.png" alt="logo-cliente">
	<img class="app--background" src="assets/background.jpg" alt="">
  <div class="container app--container-foto-inicio">
	  <router-outlet></router-outlet>
  </div>
  <div class="app--footer-container">
    <div class="app--footer-container-text">
      Novo Nordisk<sup>®</sup> es una marca registrada propiedad de Novo Nordisk A/S. Material revisado y aprobado por la Dirección de Asuntos Médicos y Regulatorios de Novo Nordisk<sup>®</sup>. Para uso exclusivo del profesional de la salud y en Guatemala para uso exclusivo del profesional médico. Si tiene alguna solicitud de información médica escríbanos a medicalinfo_clat@novonordisk.com <br>
      <strong>CLA24DI00419</strong>
    </div>
    <div class="app--footer-container-logo" >
      <img src="assets/logo-nn.png" alt="">
    </div>
  </div>
  <!-- <img class="app--logo_3" src="assets/logo-impulsando-diabetes.png" alt="" *ngIf="showLogo"> -->
</main>
